module.exports = __webpack_public_path__ + "static/img/dsf_02.0daa115.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dsfRobot/dsf_02.png
// module id = BVzE
// module chunks = 36